import { useEffect, useRef, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, TextField, Typography } from '@mui/material';

import useErrorHandler from '../../services/error-handler';
import { StyledDialogTitle } from '../StyledComponents';

const CorrectionDialog = ({ item, store, onClose }) => {
    const errorHandler = useErrorHandler();

    const [quantity, setQuantity] = useState('');
    const [note, setNote] = useState('');

    const iRef = useRef(null);

    useEffect(() => {
        if (!item) setQuantity('');
    }, [item]);

    const onQuantityChange = (event) => {
        let input = event.target.value;
        if (!/^[-\d.,]*$/.test(input)) return;

        input = input.replace(',', '.');
        if ((input.match(/-/g) || []).length > 1 || (input.includes('-') && input[0] !== '-')) return;

        if ((input.match(/\./g) || []).length > 1) return;
        setQuantity(input);
    };

    const onApplyButtonClick = async () => {
        try {
            if (isNaN(+quantity)) throw new Error('Указано не возможное количество компонентов');
            const n = note.length > 0 ? note : null;
            await store.update(item, +quantity, n);
            onClose();
        } catch (e) {
            errorHandler(e);
        }
    };

    if (!item) return null;
    return (
        <Dialog
            open={item}
            onClose={onClose}
            TransitionProps={{ onEntered: () => iRef.current && iRef.current.focus() }}
        >
            <StyledDialogTitle>Коррекция наличия компонентов</StyledDialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Typography>Корректировать наличие компонента на указанную величину:</Typography>
                </DialogContentText>
                <TextField
                    size="small"
                    fullWidth
                    value={quantity}
                    onChange={onQuantityChange}
                    inputRef={iRef}
                    inputProps={{ inputMode: 'decimal', pattern: '[-]?[0-9]*[.,]?[0-9]*' }}
                />
                <DialogContentText sx={{ mt: 2 }}>
                    <Typography>Причина корректировки:</Typography>
                </DialogContentText>
                <TextField
                    size="small"
                    fullWidth
                    multiline
                    maxRows={5}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button color="success" variant="contained" onClick={onApplyButtonClick}>
                    Применить
                </Button>
                <Button onClick={onClose} variant="outlined">
                    Отмена
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CorrectionDialog;
